export default __webpack_public_path__ + "static/step2-f0c64c3780d7e3371ebca5c59ce5205f.webp";